document.addEventListener('DOMContentLoaded', function() {
  const provinceRadios = document.querySelectorAll('input[name="province"]');
  const description = document.getElementById('holiday-shipping-description');
  const isDesktop = window.matchMedia('(min-width: 750px)').matches;
  const isHorizontalMobile = window.matchMedia('(min-width: 625px)').matches;

  function scrollToSection() {
    setTimeout(() => {
      if(isDesktop || isHorizontalMobile) {
        document.querySelector('.table-container.active').scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        document.querySelector('.map-container').scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 150);
  }
  
  // Function to handle province selection
  function selectProvince(provinceValue) {
    const radio = document.querySelector(`input[name="province"][value="${provinceValue}"]`);
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change'));
    }
  }
  
  // Add click handlers to labels for re-selecting same province
  const provinceLabels = document.querySelectorAll('.province-select__options label');
  let labelWasClicked = false;
  
  provinceLabels.forEach(label => {
    label.addEventListener('mousedown', function(e) {
      labelWasClicked = true;
      setTimeout(() => {
        labelWasClicked = false;
      }, 500);
    });
    
    label.addEventListener('click', function(e) {
      const radioId = this.getAttribute('for');
      const radio = document.getElementById(radioId);
      
      if (radio && radio.checked) {
        e.preventDefault();
        
        const details = document.querySelector('.province-select__container details');
        if (details) {
          details.removeAttribute('open');
        }
        scrollToSection();
      }
    });
  });
  
  provinceRadios.forEach(radio => {
    radio.addEventListener('change', function() {
      if (this.checked) {
        const selectedProvince = this.value;
        const summary = document.querySelector('.province-select summary');
        const summarySpan = summary.querySelector('span');
        const summaryImg = summary.querySelector('img');
        const summaryDiv = summary.querySelector('div')
        const selectedLabel = document.querySelector(`label[for="${this.id}"]`)
        const selectedImg = selectedLabel.querySelector('img');
        const selectedSpan = selectedLabel.querySelector('span');
        
        const provinces = ['BC', 'AB', 'SK', 'MB', 'ON', 'QC', 'NB', 'NS', 'PE', 'NL', 'YT', 'NT', 'NU'];
        provinces.forEach(id => {
          const province = document.getElementById(id);
          let provinceIslands = document.getElementById(`i-CA-${id}`);
          
          if ((id === 'NT' || id === 'NU') && !provinceIslands) {
            provinceIslands = document.getElementById('i-CA-NT-NU');
          }
          
          if (province) {
            province.setAttribute("fill", "#d3d3d3");
            province.classList.remove('selected');
            // Clear inline styles on all province paths
            const provincePaths = province.querySelectorAll('path');
            provincePaths.forEach(path => {
              path.style.removeProperty('fill');
            });
          }
          if (provinceIslands) {
            provinceIslands.setAttribute("fill", "#d3d3d3");
            provinceIslands.classList.remove('selected');
            // Clear inline styles on all island paths
            const paths = provinceIslands.querySelectorAll('path');
            paths.forEach(path => {
              path.style.removeProperty('fill');
            });
          }
        });

        // Highlight selected province
        if (selectedProvince) {
          const province = document.getElementById(selectedProvince);
          if (province) {
            province.setAttribute("fill", "red");
            province.classList.add('selected');
            // Set fill directly on all province paths to override CSS
            const provincePaths = province.querySelectorAll('path');
            provincePaths.forEach(path => {
              path.style.setProperty('fill', 'red', 'important');
            });
          }

          // Handle islands - check for both regular and shared NT-NU islands
          let provinceIslands = document.getElementById(`i-CA-${selectedProvince}`);
          
          // Special handling for NT and NU - they share islands in i-CA-NT-NU group
          if ((selectedProvince === 'NT' || selectedProvince === 'NU') && !provinceIslands) {
            provinceIslands = document.getElementById('i-CA-NT-NU');
          }
          
          if (provinceIslands) {
            provinceIslands.setAttribute("fill", "red");
            provinceIslands.classList.add('selected');
            // Set fill directly on all island paths
            const paths = provinceIslands.querySelectorAll('path');
            paths.forEach(path => {
              path.style.setProperty('fill', 'red', 'important');
            });
          }
        }

        // Show/hide tables based on selected province
        const allTables = document.querySelectorAll('.holiday-shipping-deadlines .table-container');
        allTables.forEach(table => {
          table.classList.remove('active');
          table.setAttribute('aria-hidden', 'true');
        });

        const selectedTable = document.querySelector(`.holiday-shipping-deadlines .table-container[data-province="${selectedProvince}"]`);
        if (selectedTable) {
          selectedTable.classList.add('active');
          selectedTable.setAttribute('aria-hidden', 'false');
        }

        // Swap summary element
        summarySpan.innerHTML = selectedSpan.innerHTML;

        const img = document.createElement('img');
        img.src = selectedImg.src;
        img.srcset = selectedImg.srcset;
        img.alt = selectedImg.alt;
        img.width = '32';
        img.height = '24';
        
        const div = document.createElement('div');
        div.classList.add('t');
        div.appendChild(img);

        if(summaryImg) {
          summaryImg.replaceWith(img);
        } else {
          summaryDiv.insertBefore(div, summarySpan);
        }

        // Close the dropdown after updating
        const details = document.querySelector('.province-select__container details');
        
        // Small delay to check focus state (Firefox needs this)
        setTimeout(() => {
          const focusedElement = document.activeElement;
          const isRadioFocused = focusedElement && focusedElement.matches('input[name="province"]');
          
          if (isRadioFocused && !labelWasClicked && selectedTable) {
            const tableHeading = selectedTable.querySelector('h3');
            if (tableHeading) {
              // Close dropdown first for keyboard users
              if (details) {
                details.removeAttribute('open');
              }
              // Make heading focusable and focus it
              tableHeading.setAttribute('tabindex', '-1');
              // Small delay to let the dropdown close
              setTimeout(() => {
                tableHeading.focus();
                // Remove tabindex after focusing so it's not in tab order
                tableHeading.addEventListener('blur', function() {
                  tableHeading.removeAttribute('tabindex');
                }, { once: true });
              }, 100);
            }
          } else {
            if (details) {
              details.removeAttribute('open');
            }
            scrollToSection();
          }
        }, 10);

        // Show description
        if (description) {
          description.style.display = 'block';
        }
      }
    });
  });

  // Close details container when clicking outside
  var details = document.querySelector('.province-select__container details');
  document.addEventListener('click', function(e) {
    if (!details.contains(e.target)) {
      details.removeAttribute('open');
    } 
  });

  // Add click handlers to map provinces (desktop only)
  if (isDesktop) {
    const provinces = ['BC', 'AB', 'SK', 'MB', 'ON', 'QC', 'NB', 'NS', 'PE', 'NL', 'YT', 'NT', 'NU'];
    
    const hoverColor = 'rgb(243, 191, 187)';
    
    // Track which islands have been set up to avoid duplicate handlers
    const setupIslands = new Set();
    
    provinces.forEach(provinceId => {
      const provinceElement = document.getElementById(provinceId);
      let provinceIslands = document.getElementById(`i-CA-${provinceId}`);
      
      // Special handling for NT and NU - they share islands in i-CA-NT-NU group
      const isSharedIsland = (provinceId === 'NT' || provinceId === 'NU') && !provinceIslands;
      if (isSharedIsland) {
        provinceIslands = document.getElementById('i-CA-NT-NU');
      }
      
      if (provinceElement) {
        provinceElement.style.cursor = 'pointer';
        provinceElement.addEventListener('click', function() {
          selectProvince(provinceId);
        });
        
        // Add hover to change island fill directly
        provinceElement.addEventListener('mouseenter', function() {
          if (provinceIslands && !provinceElement.classList.contains('selected') && !provinceIslands.classList.contains('selected')) {
            const paths = provinceIslands.querySelectorAll('path');
            paths.forEach(path => {
              path.style.setProperty('fill', hoverColor, 'important');
            });
          }
        });
        
        provinceElement.addEventListener('mouseleave', function() {
          if (provinceIslands && !provinceElement.classList.contains('selected') && !provinceIslands.classList.contains('selected')) {
            const paths = provinceIslands.querySelectorAll('path');
            paths.forEach(path => {
              path.style.removeProperty('fill');
            });
          }
        });
      }
      
      // Only set up island handlers once per island group
      if (provinceIslands && !setupIslands.has(provinceIslands.id)) {
        setupIslands.add(provinceIslands.id);
        provinceIslands.style.cursor = 'pointer';
        
        // For shared NT-NU islands, we need special handling
        if (provinceIslands.id === 'i-CA-NT-NU') {
          provinceIslands.addEventListener('click', function() {
            // Default to NT when clicking shared islands
            selectProvince('NT');
          });
          
          provinceIslands.addEventListener('mouseenter', function() {
            const ntElement = document.getElementById('NT');
            const nuElement = document.getElementById('NU');
            const ntSelected = ntElement && ntElement.classList.contains('selected');
            const nuSelected = nuElement && nuElement.classList.contains('selected');
            
            if (!ntSelected && !nuSelected) {
              // Highlight the island paths
              const islandPaths = provinceIslands.querySelectorAll('path');
              islandPaths.forEach(path => {
                path.style.setProperty('fill', hoverColor, 'important');
              });
              
              // Highlight both NT and NU provinces
              if (ntElement) {
                const ntPaths = ntElement.querySelectorAll('path');
                ntPaths.forEach(path => {
                  path.style.setProperty('fill', hoverColor, 'important');
                });
              }
              if (nuElement) {
                const nuPaths = nuElement.querySelectorAll('path');
                nuPaths.forEach(path => {
                  path.style.setProperty('fill', hoverColor, 'important');
                });
              }
            }
          });
          
          provinceIslands.addEventListener('mouseleave', function() {
            const ntElement = document.getElementById('NT');
            const nuElement = document.getElementById('NU');
            const ntSelected = ntElement && ntElement.classList.contains('selected');
            const nuSelected = nuElement && nuElement.classList.contains('selected');
            
            if (!ntSelected && !nuSelected) {
              // Remove highlight from island paths
              const islandPaths = provinceIslands.querySelectorAll('path');
              islandPaths.forEach(path => {
                path.style.removeProperty('fill');
              });
              
              // Remove highlight from both NT and NU provinces
              if (ntElement) {
                const ntPaths = ntElement.querySelectorAll('path');
                ntPaths.forEach(path => {
                  path.style.removeProperty('fill');
                });
              }
              if (nuElement) {
                const nuPaths = nuElement.querySelectorAll('path');
                nuPaths.forEach(path => {
                  path.style.removeProperty('fill');
                });
              }
            }
          });
        } else {
          // Regular island group handling
          provinceIslands.addEventListener('click', function() {
            selectProvince(provinceId);
          });
          
          provinceIslands.addEventListener('mouseenter', function() {
            if (!provinceElement || (!provinceElement.classList.contains('selected') && !provinceIslands.classList.contains('selected'))) {
              // Highlight the island paths
              const islandPaths = provinceIslands.querySelectorAll('path');
              islandPaths.forEach(path => {
                path.style.setProperty('fill', hoverColor, 'important');
              });
              
              // Also highlight the province paths
              if (provinceElement) {
                const provincePaths = provinceElement.querySelectorAll('path');
                provincePaths.forEach(path => {
                  path.style.setProperty('fill', hoverColor, 'important');
                });
              }
            }
          });
          
          provinceIslands.addEventListener('mouseleave', function() {
            if (!provinceElement || (!provinceElement.classList.contains('selected') && !provinceIslands.classList.contains('selected'))) {
              // Remove highlight from island paths
              const islandPaths = provinceIslands.querySelectorAll('path');
              islandPaths.forEach(path => {
                path.style.removeProperty('fill');
              });
              
              // Remove highlight from province paths
              if (provinceElement) {
                const provincePaths = provinceElement.querySelectorAll('path');
                provincePaths.forEach(path => {
                  path.style.removeProperty('fill');
                });
              }
            }
          });
        }
      }
    });
  }
});